export const { memo } = (()=> { //Use an iffe to create lexical scope to hold the cache.
    //Private data    
    const
        cache = {},
        //We need an old fashioned funtction in order to have access to the arguements object.
        cashier = (func: any) => function (...args: any[]) {
            const
                params = Array.prototype.slice.call(args),
                key = JSON.stringify(params),
                cacheEntry = cache[key];
            return cacheEntry ? cacheEntry : cache[key] = func.apply(null, params);
        };
    //Revealing module    
    return {
        memo: (func: any) => cashier(func)
    }
})();try {
    // @ts-ignore
    memo.displayName = "memo";
    // @ts-ignore
    memo.__docgenInfo = { "description": "", "displayName": "memo", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/memoization/memo.ts#memo"] = { docgenInfo: memo.__docgenInfo, name: "memo", path: "src/shared/memoization/memo.ts#memo" };
}
catch (__react_docgen_typescript_loader_error) { }